import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Redirect} from 'react-router-dom';
import queryString from 'query-string-es5';
import {FormattedMessage} from 'react-intl';
import {Card} from '@resurs/tron-react';
import Loader from '../../components/Loader';
import {
  clearStatus,
  statusSubscribe,
} from '../../store/actions/credit-assessment-actions';
import '../../styles/general-styles.css';

const SubscribeContainer = () => {
  const dispatch = useDispatch();
  const url = window.location.search;
  const [data] = useState(queryString.parse(url));
  const {status, statusRedirectUri} = useSelector((state) => state.cwa.status);

  useEffect(() => {
    if (data) {
      dispatch(clearStatus());
      if (data?.credit_assessment_case_id && data?.subscription_type) {
        dispatch(
          statusSubscribe(
            data?.credit_assessment_case_id,
            data?.subscription_type,
          ),
        );
      }
    }
  }, [dispatch, data]);

  useEffect(() => {
    if (status === 'COMPLETE' && statusRedirectUri) {
      window.location.replace(statusRedirectUri);
    }
  }, [status, statusRedirectUri]);

  if (status === 'TIMED_OUT') {
    return <Redirect to="/timeout" />;
  }

  return (
    <div className="container container--fixed pt-50">
      <Card className="h-100 border-0 mx-auto max-w-800 rounded-0 align-items-center">
        <h4 className="header-font ml-3">
          {data?.subscription_type === 'AWAIT_MAIN_APPLICANT' ? (
            <FormattedMessage
              id="SubscribeContainer.pageHeaderCoAppAwait"
              defaultMessage="Venter på medansøger"
            />
          ) : (
            <FormattedMessage
              id="SubscribeContainer.pageHeader"
              defaultMessage="Bearbejder dine oplysninger"
            />
          )}
        </h4>
        <span className="ml-3">
          {data?.subscription_type === 'AWAIT_MAIN_APPLICANT' ? (
            <FormattedMessage
              id="SubscribeContainer.pageSubHeaderCoAppAwait"
              defaultMessage="Din medansøger skal afslutte ansøgningen inden du kan fortsætte."
            />
          ) : (
            <FormattedMessage
              id="SubscribeContainer.pageSubHeader"
              defaultMessage="Indsamler dine oplysninger..."
            />
          )}
        </span>
        <Loader />
      </Card>
    </div>
  );
};

export default SubscribeContainer;
